export default class BundleComparison
{
  private readonly scrollHandler: EventListener;
  private readonly resizeHandler: EventListener;
  private readonly clickHandler: EventListener;
  private readonly wrapper: HTMLElement;
  private readonly scrollContainer: HTMLElement;
  private readonly columnHeaderCell: HTMLTableCellElement;
  private readonly scrollLeftButton: HTMLButtonElement | null = null;
  private readonly scrollRightButton: HTMLButtonElement | null = null;
  constructor(wrapper: HTMLElement)
  {
    this.wrapper = wrapper;

    const scrollContainer = this.wrapper.querySelector('.scroll-container');
    if(scrollContainer instanceof HTMLElement) {
      this.scrollContainer = scrollContainer;
    } else {
      this.scrollContainer = this.wrapper;
    }

    const columnHeaderCell = this.wrapper.querySelector('table tbody th:first-child');
    if(columnHeaderCell instanceof HTMLTableCellElement) {
      this.columnHeaderCell = columnHeaderCell;
    } else {
      throw new Error("Column header cell not found");
    }

    const scrollRightButton = this.wrapper.querySelector('.button-scroll-comparison-right');
    if(scrollRightButton instanceof HTMLButtonElement) {
      this.scrollRightButton = scrollRightButton;
    }

    const scrollLeftButton = this.wrapper.querySelector('.button-scroll-comparison-left');
    if(scrollLeftButton instanceof HTMLButtonElement) {
      this.scrollLeftButton = scrollLeftButton;
    }

    this.scrollHandler = this.handleScrollEvent.bind(this);
    this.resizeHandler = this.handleResizeEvent.bind(this);
    this.clickHandler = this.handleClickEvent.bind(this);
    this.enable();
  }

  private enable(): void
  {
    this.scrollContainer.addEventListener('scroll', this.scrollHandler, false);
    this.wrapper.addEventListener('click', this.clickHandler, true);
    window.addEventListener('resize', this.resizeHandler, false);

    this.detectOverflow();

    //timeout because of safari? maybe because of vite?
    setTimeout(() => {
      this.updateLeftButtonPosition();
    }, 500)
  }

  private handleScrollEvent(event: Event): void
  {
    const isScrolled = (this.scrollContainer.scrollLeft > 0);
    this.wrapper.classList.toggle('is-scrolled', isScrolled);

    if(isScrolled) {
      const isFullyScrolled = (this.scrollContainer.scrollLeft + this.scrollContainer.offsetWidth >= this.scrollContainer.scrollWidth);
      this.wrapper.classList.toggle('is-scrolled-right', isFullyScrolled);
    }
  }

  private handleResizeEvent(): void
  {
    this.detectOverflow();
    this.updateLeftButtonPosition();
  }

  private handleClickEvent(event: MouseEvent): void
  {
    if(event.target) {
      switch (true) {
        case event.target == this.scrollLeftButton:

          //prevent overshoot
          const scrollLeftRemaining = this.scrollContainer.scrollLeft;
          this.scrollContainer.scrollBy({left: -1 * Math.min(scrollLeftRemaining, 150), behavior: 'smooth'});

          break;
        case event.target == this.scrollRightButton:

          //prevent overshoot
          const scrollRightRemaining = this.scrollContainer.scrollWidth - this.scrollContainer.offsetWidth - this.scrollContainer.scrollLeft;
          this.scrollContainer.scrollBy({left: Math.min(scrollRightRemaining, 150), behavior: 'smooth'});
          break;
      }
    }
  }

  private detectOverflow(): void
  {
    const isOverflow = this.scrollContainer.scrollWidth > this.scrollContainer.offsetWidth;
    this.wrapper.classList.toggle('is-overflow', isOverflow);

    
  }

  private updateLeftButtonPosition(): void
  {
    const columnHeaderWidth = this.columnHeaderCell.offsetWidth;
    this.scrollLeftButton?.style.setProperty('--left', columnHeaderWidth + 'px');
  }
}